import {z} from 'zod'
import {StripeProductId} from './StripeProductId.js'

export const StripeSubscriptionProductIds = z.object({
  starter: StripeProductId,
  basic: StripeProductId,
  pro: StripeProductId,
})
export type StripeSubscriptionProductIds = z.infer<typeof StripeSubscriptionProductIds>
